exports.list = {
    path: '/pemasukan',
    name: 'pemasukan_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/pemasukan/List.vue"),
}
exports.show = {
    path: '/pemasukan/show/:id',
    name: 'pemasukan_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pemasukan/Show.vue"),
}